import {parse, stringify} from 'qs';

const PRE_QUERY_PARAMS = '?';

export const getQueryParams = queryString => parse(queryString.substr(PRE_QUERY_PARAMS.length));

export const createQueryParams = query => PRE_QUERY_PARAMS + stringify(query);

export const setQueryParams = (props, key, value) => {
    const {
        history,
        history:{location: {pathname, search}}
    } = props;
    const query = getQueryParams(search);


    const searchText = createQueryParams({
        ...query,
        [key]: value
    });

    history.push({
        pathname,
        search: searchText
    });
};

export const cleanQueryParams = props => {
    const {
        history,
        history:{location: {pathname}}
    } = props;

    history.push({
        pathname,
        search: ''
    });
};


export const removeQueryParams = (props, key) => {
    const {
        history,
        history:{location: {pathname, search}}
    } = props;
    const query = getQueryParams(search);

    if (key instanceof Array) {
        key.forEach(_key => {
            delete query[_key];
        });
    } else {
        delete query[key];
    }

    const searchText = createQueryParams(query);

    history.push({
        pathname,
        search: searchText
    });
};



// WEBPACK FOOTER //
// ./src/util/router.js